<template>
<div>
  <div>{{ file }}</div>
  <vs-alert color="danger" v-if="amountDanger">
    <div>{{ $t('message.salaryProject.amountNull') }}</div>
  </vs-alert>
  <div class="mx-auto sm:w-192 mt-8 w-full">
    <div class="flex mb-4">
      <div class="w-1/4 leading-form text-right mr-4">{{ $t('message.salaryProject.tableHeaderStatus') }}</div>
      <div class="w-3/4 leading-form">{{ $tc('message.salaryProject.actsStatus', data.status) }}</div>
    </div>
    <div class="flex mb-4">
      <div class="w-1/4 leading-form text-right mr-4">{{ $t('message.salaryProject.formPaymentNumber') }}</div>
      <vs-input class="inputx w-3/4" v-model="paymentNumber" :disabled="readOnly" />
    </div>
    <div class="flex mb-4" v-if="false">
      <div class="w-1/4 leading-form text-right mr-4">{{ $t('message.salaryProject.formPaymentType') }}</div>
      <vs-select class="inputx w-3/4" v-model="paymentType" :autocomplete="true" :disabled="readOnly">
        <vs-select-item :key="null" :value="null" text="-" />
      </vs-select>
    </div>
    <div class="flex mb-4">
      <div class="w-1/4 leading-form text-right mr-4">{{ $t('message.salaryProject.formPaymentBill') }}</div>
      <div class="w-3/4 leading-form">{{ paymentBill }}</div>
    </div>
    <div class="flex mb-4">
      <div class="w-1/4 leading-form text-right mr-4">{{ $t('message.salaryProject.formPaymentContact') }}</div>
      <vs-input class="inputx w-3/4" v-model="paymentContact" :disabled="readOnly" />
    </div>
    <div class="flex mb-4">
      <div class="w-1/4 leading-form text-right mr-4">{{ $t('message.salaryProject.formPaymentPhone') }}</div>
      <vs-input class="inputx w-3/4" v-model="paymentPhone" :disabled="readOnly" />
    </div>
    <div class="flex mb-4">
      <div class="w-1/4 leading-form text-right mr-4">{{ $t('message.salaryProject.formPaymentNote') }}</div>
      <vs-input class="inputx w-3/4" v-model="paymentNote"/>
    </div>
  </div>
  <div class="w-full mx-auto" v-if="data.id">
    <div class="w-full">
      <vs-input class="inputx sm:w-1/2 w-full" v-model="filter" v-if="false"
        :placeholder="$t('message.salaryProject.tableHeaderFio')"/>
      <label class="leading-form text-left cursor-pointer underline text-primary float-right">
        <span v-if="!file">{{ $t('message.salaryProject.formActUpload') }}</span>
        <span v-if="file">{{ $t('message.salaryProject.formUploadAdded') }}</span>
        <input type="file" class="hidden" @change="uploadFile($event)">
        <a href="/salaryTemplate.xlsx" class="ml-6">{{ $t('message.salaryProject.formGetTemplate') }}</a>
      </label>
    </div>
    <vs-table
      stripe :data="filteredTableData" pagination :maxItems="30"
      class="w-full mt-4" :noDataText="$t('message.salaryProject.noDataText')">
      <template slot="thead">
        <vs-th>{{ $t('message.salaryProject.tableHeaderFio') }}</vs-th>
        <vs-th>{{ $t('message.salaryProject.tableHeaderPost') }}</vs-th>
        <vs-th>{{ $t('message.salaryProject.tableHeaderMain') }}</vs-th>
        <vs-th>{{ $t('message.salaryProject.tableHeaderAmount') }}</vs-th>
        <vs-th></vs-th>
        <vs-th>{{ $t('message.salaryProject.tableHeaderActions') }}</vs-th>
      </template>
      <template :slot-scope="{filteredTableData}">
        <template  v-for="(row, index) in filteredTableData">
          <vs-tr :key="`${row.id}data`">
            <vs-td>
              {{ row.fio }}
              <br />
              {{row.tp_tin_txt}}
            </vs-td>
            <vs-td>{{ row.post }}</vs-td>
            <vs-td>{{ row.bill }}</vs-td>
            <vs-td>
              <vs-input class="inputx w-64" :value="row.amount" @blur="setAmount(row, $event.target.value)" />
            </vs-td>
            <vs-td class="text-danger">{{ row.salary_error }}</vs-td>
            <vs-td class="text-center">
              <vs-button color="primary" class="inline-block mr-2" @click="removeRow(row)"
                         type="border" icon="remove" v-if="!stopAdd" />
            </vs-td>
          </vs-tr>
          <vs-tr :key="`${row.id}label`" v-if="row.labels">
            <vs-td colspan="5" class="label-row">
              <template v-for="(label, key) in row.labels">
                <span :key="`${row.id}label${key}`" class="leading-loose" @click="removeLabel(index, key)">
                  {{ label }}
                  <vs-icon icon="close"></vs-icon>
                </span>
              </template>
              <vs-input class="inputx sm:w-32 ml-2 w-full" @change="addLabel(index, $event.target.value)" />
            </vs-td>
          </vs-tr>
        </template>
        <vs-tr :key="'add'" v-if="!stopAdd">
          <vs-td>
            <vs-select v-model="add.employee" class="w-full">
              <template v-for="employee of employees">
                <vs-select-item :value="employee.id" :text="employee.tp_name" :key="employee.id">
                </vs-select-item>
              </template>
            </vs-select>
          </vs-td>
          <vs-td>{{ add.post }}</vs-td>
          <vs-td>{{ add.bill }}</vs-td>
          <vs-td>
            <vs-input class="inputx w-64" v-model="add.amount" :danger="amountDanger"/>
          </vs-td>
          <vs-td class="text-center">
            <vs-button color="primary" class="inline-block mr-2" @click="addEmployee"
                       type="border" icon="save" />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
  <div class="w-full sm:w-4/5 text-center mt-8 mx-auto" v-if="false">
    <vs-checkbox v-model="agree">{{ $t('message.salaryProject.formConfirm') }}</vs-checkbox>
  </div>
  <div class="w-full sm:w-2/3 mt-24 mx-auto">
    <vs-button @click="$emit('close-form')" line-origin="center"
               color="primary" type="flat" class="my-2 mr-2">
      {{ $t('message.salaryProject.formBack') }}
    </vs-button>
    <vs-button @click="annulAct" line-origin="center"
               color="primary" type="flat" class="my-2 mr-2">
      {{ $t('message.salaryProject.formAnnul') }}
    </vs-button>
    <vs-button @click="confirmForm" line-origin="center" v-if="!stopAdd && $checkRole('accountant')"
               color="primary" type="gradient" class="my-2 mr-2 float-right">
      {{ $t('message.salaryProject.formCreate') }}
    </vs-button>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'createForm',
  props: {
    paymentBill: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    paymentNumber: '',
    paymentType: null,
    paymentContact: '',
    paymentPhone: '',
    paymentNote: '',
    stopAdd: false,
    readOnly: false,
    filter: '',
    add: {
      employee: '',
      amount: null,
      account: '',
      post: '',
      bill: ''
    },
    added: [],
    agree: false,
    file: null
  }),
  watch: {
    'add.employee' (val) {
      this.add.post = this.getEmployee[val].tp_position
      // eslint-disable-next-line multiline-ternary
      this.add.bill = (this.getEmployee[val].account_numb && this.getEmployee[val].account_numb !== '')
        ? this.getEmployee[val].account_numb : this.getEmployee[val].card_numb
    },
    'add.amount' (val) {
      this.add.amount = String(val).replace(/[^\d,.]/g, '')
    }
  },
  methods: {
    ...mapActions('salary', ['addPaymentAct', 'sendFiles', 'saveActFile', 'updateAct']),
    ...mapActions('payment', ['addTransferLocal', 'fetchTransferLocal', 'editTransferLocal', 'recallTransfer']),
    confirmForm () {
      this.$emit('get-sing-code', {
        id: this.paymentNumber,
        data: {
          head: this.data,
          body: this.transferLocal,
          paymentBill: this.paymentBill,
          note: this.paymentNote
        }
      })
    },
    async setAmount (row, amount) {
      console.log(row)
      const info = {
        amount,
        id: row.id,
        transfer_date: new Date(),
        accountNumber: this.paymentBill,
        transferId: row.id,
        commision_amount: 0,
        mf_account_c_txt: row.mf_account_c_txt
      }
      await this.editTransferLocal(info)
      await this.fetchTransfer(this.data.id)
    },
    async removeRow (row) {
      const info = {
        accountNumber: this.paymentBill,
        transferId: row.id
      }
      await this.recallTransfer(info)
      await this.fetchTransfer(this.data.id)
    },
    removeLabel (key, code) {
      this.tableData[key].labels.splice(code, 1)
    },
    addLabel (key, text) {
      this.tableData[key].labels.push(text)
    },
    getFirst () {
      for (const key in this.getEmployees) {
        if (this.added.indexOf(this.getEmployees[key].id) !== -1) {
          this.add.employee.id = this.getEmployees[key].id
          this.added.push(this.getEmployees[key].id)
          break
        }
      }
    },
    async addEmployee () {
      const account = this.getEmployee[this.add.employee].card_numb || this.getEmployee[this.add.employee].account_numb
      const date = new Date()
      if (!this.add.amount) {
        this.add.amount = 0
        return false
      }
      const info = {
        accountNumber: this.paymentBill,
        amount: this.add.amount,
        type: 4,
        transfer_date: date,
        currency_code: 'TJS',
        salary_act_id: this.data.id,
        salary_account_id: this.add.employee,
        commision_amount: 0,
        mf_account_c_txt: account
      }
      await this.addTransferLocal(info)
      await this.fetchTransfer(this.data.id)
      this.add.employee = null
      this.add.amount = null
      this.add.post = null
      this.add.bill = null
    },
    async fetchTransfer (salary) {
      await this.fetchTransferLocal({
        salary, accountNumber: this.getSalaryAccount, type: 4
      })
    },
    async uploadFile (event) {
      let file = event.target.files[0]
      const formData = new FormData()
      formData.append('files', file)
      file = await this.sendFiles(formData)
      file = {upload_file: file.files[0]}
      this.file = await this.saveActFile({actId: this.paymentNumber, file})
      window.location.reload()
    },
    async annulAct () {
      await this.updateAct({
        actId: this.data.id,
        data: {status: 2}
      })
      this.$emit('close-form')
    }
  },
  computed: {
    ...mapGetters('salary', ['getTableData', 'getEmployees', 'getEmployee']),
    ...mapGetters('utils', ['getSalaryAccount', 'getUserRole']),
    ...mapGetters('payment', ['transferLocal']),
    employees () {
      const list = []
      for (const key in this.getEmployees) {
        if (this.getEmployees[key].status === 0 && (this.getEmployees[key].account_numb !== '' || this.getEmployees[key].card_numb !== '')) {
          list.push(this.getEmployees[key])
        }
      }
      return list
    },
    filteredTableData () {
      const employees = this.getEmployee
      const transfers = this.transferLocal
      transfers.forEach(item => {
        if (employees[item.salary_account_id]) {
          item.fio = employees[item.salary_account_id].tp_name
          item.post = employees[item.salary_account_id].tp_position
          // eslint-disable-next-line multiline-ternary
          item.bill = (employees[item.salary_account_id].account_numb && employees[item.salary_account_id].account_numb !== '')
            ? employees[item.salary_account_id].account_numb : employees[item.salary_account_id].card_numb
        } else {
          item.fio = item.tp_name_txt
        }
      })
      if (this.filter === '') return transfers
      const employeesFilter = this.getEmployees.filter(item => (item.tp_name.indexOf(this.filter) !== -1))
      return this.transferLocal.filter((item) => employeesFilter.indexOf(item.salary_account_id) !== -1)
    },
    amountDanger () {
      return (this.add.amount !== null && (!this.add.amount))
    }
  },
  mounted () {
    if (this.data) {
      this.paymentNumber = this.data.id
      this.paymentContact = this.data.contact_name
      this.paymentPhone = this.data.contact_phone
      this.paymentNote = this.data.note
      this.readOnly = true
      if (this.data.status > 0) this.stopAdd = true
      this.fetchTransfer(this.data.id)
    }
  },
  destroyed () {
    this.readOnly = false
    this.paymentNumber = ''
  }
}
</script>

<style scoped lang="scss">
  .label-row {
    &:hover {
      .vs-input {
        display: inline-block;
      }
    }
    .vs-input {
      display: none;
    }
  }
</style>
